import { Typography } from "@mui/material";

export const TitleText = ({ sx, ...props }) => {
  return (
    <Typography
      {...props}
      sx={{ ...sx, fontFamily: "Bodoni Moda", fontWeight: 700 }}
    />
  );
};
